import { render } from "./SingleProjectLink.vue?vue&type=template&id=0c99aaa4&scoped=true"
import script from "./SingleProjectLink.vue?vue&type=script&lang=js"
export * from "./SingleProjectLink.vue?vue&type=script&lang=js"

import "./SingleProjectLink.vue?vue&type=style&index=0&id=0c99aaa4&lang=css"
import "./SingleProjectLink.vue?vue&type=style&index=1&id=0c99aaa4&lang=scss&scoped=true"

import exportComponent from "/home/callum/Documents/CODE/raphaelschoen/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c99aaa4"]])

export default __exports__